import React from "react";
import "./Hero.css";
import Particles from "reactparticles.js";
import {} from "reactstrap";
import { SocialIcon } from "react-social-icons";
import GithubCorner from "react-github-corner";

const socialStyle = {
  height: "5vmin",
  width: "5vmin"
};

function Hero() {
  return (
    <div className="Hero">
      <header className="Hero-header" style={{}}>
        <Particles
          id="hero-particles"
          config="configs/hero.json"
          style={{ height: "100vh" }}
        />
        <div className="Hero-blurb">
          <div>
            <div className="Hero-title">reactparticles.js</div>
            <div className="Hero-credit">by kr1tzy</div>
          </div>
          <div className="Hero-social">
            <SocialIcon
              url="http://twitter.com/kr1tzy"
              style={socialStyle}
            />{" "}
            <SocialIcon url="http://github.com/kr1tzy" style={socialStyle} />{" "}
            <SocialIcon
              url="https://codepen.io/kr1tzy"
              bgColor="#FFF"
              style={socialStyle}
            />
          </div>
        </div>
      </header>
      <GithubCorner
        href="https://github.com/kr1tzy/reactparticles.js"
        bannerColor="#64CEAA"
        octoColor="#000"
        size={80}
        direction="right"
      />
    </div>
  );
}

export default Hero;
